const DEFAULT_DIRECTORY_MESSAGE = 'Hi, I found you through Gibraltar Wedding Expo and would love to know more about your services.';

export const getDirectoryIntroMessage = () => DEFAULT_DIRECTORY_MESSAGE;

export const buildVendorEmailHref = (email, vendorName) => {
  if (!email) return '';
  const subject = encodeURIComponent(`Enquiry via Gibraltar Wedding Expo${vendorName ? ` - ${vendorName}` : ''}`);
  const body = encodeURIComponent(DEFAULT_DIRECTORY_MESSAGE);
  return `mailto:${email}?subject=${subject}&body=${body}`;
};

export const buildVendorWhatsAppHref = (whatsapp) => {
  if (!whatsapp) return '';
  const digits = whatsapp.replace(/[^0-9]/g, '');
  if (!digits) return '';
  return `https://wa.me/${digits}?text=${encodeURIComponent(DEFAULT_DIRECTORY_MESSAGE)}`;
};

export const buildSocialLink = (type, value) => {
  if (!value) return '';
  if (value.startsWith('http')) return value;
  if (type === 'instagram') return `https://instagram.com/${value.replace('@', '')}`;
  if (type === 'facebook') return `https://facebook.com/${value}`;
  if (type === 'website') return value.startsWith('www.') ? `https://${value}` : `https://${value}`;
  return value;
};